import { useEffect } from 'react';
import { useHistory } from 'react-router';
import analytics from '@lo/shared/services/analytics';

export default function useTrackPageView() {
    const history = useHistory();

    useEffect(() => {
        analytics.viewedPage();
    }, [history.location.pathname]);
}
